module.exports = __webpack_public_path__ + "assets/image-placeholder-small.461c6e70.svg";